import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Box, Slide } from "@mui/material";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ConfirmationDialog = ({ title, content, open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="confirmation-dialog-title"
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Light background
      }}
    >
      <DialogTitle id="confirmation-dialog-title" sx={{ m: 0, p: 2 }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <p>{content}</p>
          <Box display="flex" gap={2}>
        
            <Button variant="contained" style={{backgroundColor:"#0A65E5", color:"white"}} onClick={onConfirm}>
              Yes
            </Button>
            <Button variant="outlined" style={{backgroundColor:"#000A51", color:"white"}} onClick={onClose}>
              No
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
